import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useApiData } from "./ApiDataContext";
import Loader from "./components/Loader";

function RedirectWithToken() {
  const location = useLocation();  // ✅ Ensures this is inside <Router>
  const { setApiData } = useApiData();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tokenFromUrl = searchParams.get("x-amzn-marketplace-token");

    if (!tokenFromUrl) {
      setLoading(false);
      setError("Token is missing");
      return;
    }

    setToken(tokenFromUrl);
    fetchData(tokenFromUrl);
  }, [location.search]);

  const fetchData = async (token) => {
    const encodedToken = encodeURIComponent(token);
    const baseUrl = process.env.REACT_APP_CUSTOMER_API_BASE_URL;
    console.log("Base URL:", baseUrl);
    const apiUrl = `${baseUrl}?x-amzn-marketplace-token=${encodedToken}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log("Customer Data:", result);
      setApiData(result);

      const { customerID, customerAWSAccountId, productCode } = result;

      let dimension = null;
      // Safe check if Entitlements exist
      if (
        result.entitlements &&
        Array.isArray(result.entitlements.Entitlements) &&
        result.entitlements.Entitlements.length > 0
      ) {
        const entitlement = result.entitlements.Entitlements[0];
        dimension = entitlement.Dimension;
        console.log("Dimension:", dimension);
      }

      setCookie("xmas_token", token);
      setCookie("customer_id", customerID);
      setCookie("customer_identifier", customerAWSAccountId);
      setCookie("product_code", productCode);
      if (dimension) {
        setCookie("dimension", dimension);
      } else {
        setCookie("dimension", null);
      }

      const { isEntitlementsRequestOk, hasEntitlements, data: entitlementsData } =
        await fetchEntitlementsData(customerID, productCode);

      console.log("Is request OK:", isEntitlementsRequestOk);
      console.log("Has entitlements:", hasEntitlements);

      setCookie("entitlements_request_ok", isEntitlementsRequestOk);
      setCookie("has_entitlements", hasEntitlements);

      fetchLicenseData(customerID, customerAWSAccountId, productCode);
    } catch (err) {
      console.error("Error fetching customer data:", err.message);

      setError(err.message);
      setLoading(false);
      return <ErrorPage />
    }
  };

  const fetchLicenseData = async (customerId, customerAWSAccountId, productCode) => {
    const baseUrl = process.env.REACT_APP_LICENSE_API_BASE_URL;
    const licenseApiUrl = `${baseUrl}?customerId=${customerId}&customerAWSAccountId=${customerAWSAccountId}&productCode=${productCode}`;

    try {
      const response = await fetch(licenseApiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log("License Data:", result);

      handleLicenseResponse(result);
    } catch (err) {
      console.error("Error fetching license data:", err.message);
      return <ErrorPage />
    }
  };

  const fetchEntitlementsData = async (customerId, productCode) => {
    const baseUrl = process.env.REACT_APP_ENTITLEMENT_API_BASE_URL;
    const entitlementsApiUrl = `${baseUrl}?CustomerIdentifier=${customerId}&ProductCode=${productCode}`;

    try {
      const response = await fetch(entitlementsApiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const isEntitlementsRequestOk = response.ok;

      const result = await response.json();
      console.log("Entitlements Data:", result);

      const hasEntitlements = Array.isArray(result.entitlements) && result.entitlements.length > 0;

      return {
        isEntitlementsRequestOk,
        hasEntitlements,
        data: result,
      };
    } catch (err) {
      console.error("Error fetching entitlements data:", err.message);
      return {
        isEntitlementsRequestOk: false,
        hasEntitlements: false,
        data: null,
      };
    }
  };

  const handleLicenseResponse = (licenseData) => {
    const { customerResponse, subscriptionResponse } = licenseData;
    console.log("Customer Response:", customerResponse);
    console.log("Subscription Response:", subscriptionResponse);
    if (customerResponse.success && subscriptionResponse.success) {
      window.location.href = process.env.REACT_APP_SERVER_URL;
    } else if (customerResponse.success && !subscriptionResponse.success) {
      console.log("Redirecting to login form");
      setCookie("licCustomer", customerResponse.client_name);
      window.location.href = "/login";
    } else {
      console.log("Redirecting to register form");
      window.location.href = "/register";
    }
  };

  if (loading) return <Loader />;
  if (error) return <ErrorPage />;

  return null;
}

function setCookie(name, value, days = 7) {
  const expires = new Date(Date.now() + days * 86400000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
}

function ErrorPage() {
  return (
    <div className="form_wrapper">
      <div className="content">
        <div className="error_container">
          <article className="error_article">
            <img className="error_icon" src="/img/404.svg" alt="Error" />
          </article>
          <article style={{ textAlign: "center" }} className="error_article_text">
            <h4><b>Page Not Found.</b></h4>
            <p>Sorry, we could not find the page you are looking for.</p>
          </article>
          <div className="tiger-btn-placement-alt">
            <button className="primary-tiger-button" onClick={() => window.history.back()}>
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RedirectWithToken;